import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {Message} from 'semantic-ui-react'

class FormErrorMessage extends Component {
    //access router
    //this.props.history.push('/dashboard')
    
    render() {
        const {message} = this.props;
        return (
            <Message positive>
                <p>
                    {message}
                </p>
            </Message>
        )
    }
}

FormErrorMessage.propTypes = {
    message: PropTypes.string
};

export default FormErrorMessage


// WEBPACK FOOTER //
// ./src/components/utils/FormSuccessMessage.js